/** @jsx jsx **/
import { Box, jsx } from 'theme-ui'
import theme from '~/gatsby-plugin-theme-ui'
import { CartItem } from '~/components/cart-item'
import { useCartContext } from '~/context/cart-context'
import { CheckoutLineItemInput, CheckoutProductVariant } from '~/@types/models'
import useQuantityNote from '~/hooks/use-quantity-note'
import { trackViewCart } from '~/utils/marketing/track'
import { lineItemPrice } from '~/utils/price'
const CartOverlayBody = () => {
  const { items, saveItem, totalPrice } = useCartContext()
  const { getNoteBySelectedQuantity } = useQuantityNote({})

  const updateQuantity = async (
    variant: CheckoutProductVariant,
    title: string,
    newValue: number
  ) => {
    const currentItem = items && items.find(item => item.variant.shopifyId === variant.shopifyId)
    const message = getNoteBySelectedQuantity(
      variant.quantityAvailable,
      ((currentItem && currentItem.quantity) as number) + newValue
    )

    const updatedItem: CheckoutLineItemInput = {
      variantId: variant.id,
      quantity: newValue,
      customAttributes: [
        {
          key: `Quantity`,
          value: message,
        },
      ],
    }

    await saveItem(updatedItem, title, variant)

    const contents = items.map(item => {
      return {
        item_id: item.id,
        item_name: item.title,
        item_category: item.productType,
        item_variant: item.color,
        price: lineItemPrice(false, item),
        quantity: item.quantity,
      }
    })
    trackViewCart({
      totalPrice,
      contents,
    })
  }

  return (
    <Box
      sx={{
        flex: 'auto',
        minHeight: '1%',
        overflow: 'auto',
        mr: [0],
        pr: ['20px', '0'],
        pl: [null, '50px'],
        pt: [null, '70px'],
        pb: [null, '0'],
      }}
    >
      {items &&
        items.map(item => (
          <CartItem
            variant="secondary"
            data-cy="cart-item"
            item={item}
            key={`${item.id}${item.quantity}`}
            onQuantityUpdate={updateQuantity}
            source="cart-flyout"
          />
        ))}
    </Box>
  )
}

export default CartOverlayBody
